// ----------------------------------------------------------------------------
// Component: Content Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_content-panel.scss';

// Content Panel - Video
import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';



const playAutoplayVideo = video => {
    if (video.dataset.userPaused) return;

    //Show loading animation.
    video.setAttribute('autoplay', 'autoplay');
    let playPromise = video.play();

    if (playPromise !== undefined) {
        playPromise
            .then(() => {
                // Automatic playback started!
                // Show playing UI.
                video.classList.add('autoplay--success');
            })
            .catch(error => {
                if (error.name === 'NotAllowedError') {
                    // Autoplay settings disabled in browser
                } else {
                    throw error;
                }
            });
    }
};

const autoPlayingObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            playAutoplayVideo(entry.target);
        }
    });
},
{ threshold: 0.5, root: null });

function initAutoPlayVideos() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if(prefersReducedMotion && !prefersReducedMotion.matches) {
        let autoplayingVideos = document.querySelectorAll('.content-panel--video video');

        autoplayingVideos.forEach(function(autoplayingVideo) {
            autoPlayingObserver.observe(autoplayingVideo);
        });
    }
}

document.addEventListener('DOMContentLoaded', initAutoPlayVideos);
